exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".listing h2{margin:0 0 10px 0; font-size: 25px;}\n.listing h2 span.red_shape{height:25px;}\nul.event_list li .inner_list img{width: 100%;}\nul.event_list li{margin-bottom:20px;}\nul.event_list li .inner_list h3{font-weight: normal; font-size: 22px; margin-top: 10px; }\n/*ul.event_list li .inner_list a{text-decoration: underline;}*/\nul.event_list li .inner_list a:hover, ul.event_list li .inner_list a:focus{color:#b50721;}\nul.event_list li .inner_list address{margin-bottom: 8px;}\nul.event_list li .inner_list p{margin: 8px 0 0 0;}\n.inner_list p label{color:#666666; font-weight: normal; margin:14px 0 0 0px; width: 100%; text-align: right; padding: 0px;}\n.inner_list span.amount{font-size: 23px; font-weight: 500; text-align: right;}\n.inner_list label{padding: 5px 15px;}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/html/nissco_event_web/angular/src/app/supplier/profile/dashboard/dashboard.component.css
// module id = ../../../../../src/app/supplier/profile/dashboard/dashboard.component.css
// module chunks = 39